import './main.vendors';

// JS - local 3rd parties
import './_components/angular_ui_map';
import './_components/angular_hal';
import './_components/angular_storage';
import './_components/local_data';
import './_components/moment_extensions';
import './_components/string_polyfills';

// Glyphicons.
import 'bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.eot';
import 'file-loader?name=fonts/[name].[ext]!bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.svg';
import 'bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf';
import 'bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.woff';
import 'bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2';

// Images.
import './_images/BB_wait.gif';
import './_images/bg-gray.png';
import './_images/google.png';
import './_images/ical.png';
import './_images/outlook.png';
import './_images/unavailable_tile.png';

// Templates
import './_templates/bookings_table_cancel_booking.html';
import './_templates/edit_booking_modal_form.html';
import './_templates/login_modal_form.html';
import './_templates/pick_company_modal_form.html';

import config from './main.config';
import translationsConfig from './_translations/en';
import run from './main.run';

import utilitiesModule from './-utilities/entry.module';
import i18nModule from './-i18n/entry.module';
import uibModule from './-uib/entry.module';
import uiSelectModule from './-ui-select/entry.module';
import toggleSwitchModule from './-toggle-switch/entry.module';
import inputsModule from './-inputs/entry.module';
import configModule from './-config/entry.module';

export default angular
    .module('BB', [
        'ngMessages',
        'ngSanitize',
        'ngFileUpload',
        'ngCookies',
        'ngAnimate',
        'angular-carousel',
        'angular-data.DSCacheFactory',
        'angular.filter',
        'pascalprecht.translate',
        'schemaForm',
        'ui.bootstrap',
        'ui.router.util',
        'ui.select',
        'ui-rangeSlider',
        'uiGmapgoogle-maps',
        'vcRecaptcha',
        'angularSpectrumColorpicker',

        'ngStorage',
        'angular-hal',
        'ui.map',
        'ngA11y',

        utilitiesModule,
        i18nModule,
        uibModule,
        uiSelectModule,
        toggleSwitchModule,
        inputsModule,
        configModule
    ])
    .config(config)
    .config(translationsConfig)
    .run(run)
    .name;


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/main.module.js